import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dbb2ed2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "country-icon iso"
}
const _hoisted_2 = ["src", "alt"]

import { computed, ComputedRef } from "vue";
import { Country } from "@/stores/data";


export default /*#__PURE__*/_defineComponent({
  __name: 'CountryIcon',
  props: {
  country: { type: Country, required: true },
},
  setup(__props) {

const props = __props;

const countryImageSrc: ComputedRef<string | undefined> = computed(() => {
  if (props.country?.iso.toLowerCase().includes("europe")) {
    return require(`@/assets/images/countries/europe.svg`);
  }

  if (props.country?.isRegion) {
    return require(`@/assets/images/countries/unknown.svg`);
  }

  try {
    return require(`@/assets/images/countries/${props.country?.iso.toLowerCase()}.svg`);
  } catch (e) {
    return undefined;
  }
});

return (_ctx: any,_cache: any) => {
  return (!countryImageSrc.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.country.iso.toUpperCase()), 1))
    : (_openBlock(), _createElementBlock("img", {
        key: 1,
        class: "country-icon",
        src: countryImageSrc.value,
        alt: __props.country.iso
      }, null, 8, _hoisted_2))
}
}

})